import {autoinject} from "aurelia-dependency-injection";
import Marionette from "../../shared/marionette-mustache";
import "../styles/user-details.less";
import { AppUser } from "../../authentication/app-user";
import { AuthService } from "../../authentication/auth-service";

const template = require<string>("./user-details.html");

const options = {
        template: template
};

@autoinject
export class UserDetailsView extends Marionette.ItemView<any> {

    constructor(private appEvents: Backbone.Events, public authService: AuthService) {
        super(options);
        this.model = authService.AppUser;
        this.setupModelListeners();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {
            "click #sign-in-link": (e) => this.signinClick(e),
            "click #ip-override-link a": (e) => this.overrideLinkClick(e),
            "click #ip-override-link-mobile a": (e) => this.overrideLinkClick(e),
            "click #name-sign-out": (e) => this.signoutClick(e),
            "click #mobile-name-sign-out": (e) => this.signoutClick(e)
        };
        return events;
    }

    private setupModelListeners(): void {
        this.model.on("ipSigningIn", () => {
            this.ipSigningIn();
        });

        this.model.on("ipSigningInFailed", () => {
            this.$("#ip-in-progress").hide();
            this.updateUserInterface();
        });

        this.model.on("refresh", () => {
            this.updateUserInterface();
        });
    }

    private overrideLinkClick(e: JQueryMouseEventObject) {
        e.preventDefault();
        const returnUrl = window.location.pathname;
        const signinUrl = `override?return=${returnUrl}`;
        Backbone.history.navigate(signinUrl, { trigger: true });
    }

    private signinClick(e: JQueryMouseEventObject) {
        e.stopPropagation();
        const returnUrl = window.location.pathname;
        const signinUrl = `signin?return=${returnUrl}`;
        Backbone.history.navigate(signinUrl, { trigger: true });
    }

    private signoutClick(e: JQueryMouseEventObject) {
        e.stopPropagation();
        const signoutUrl = `signout`;
        Backbone.history.navigate(signoutUrl, { trigger: true, replace: true });
    }

    private updateUserInterface(): void {
        this.updateSignInState();
        this.updateSignInType();
        this.updateUserName();
        this.updateOrganisation();
        this.updateBadge();
        this.updateRemainingTrialDays();
    }

    private updateRemainingTrialDays(): void {
        const remainingDays = this.model.RemainingTrialDays;
        const $link = this.$("#hs-cta-register-link");
        const $label = this.$("#user-details-trial-remaining-days");
        $link.prop("title", "Days remaining in your trial");
        if (remainingDays === null || remainingDays <= 0) {
            $link.text(remainingDays + " days remaining");
            $label.hide();
        } else if (remainingDays === 1) {
            $link.text(remainingDays + " day remaining");
            $label.show();
        } else {
            $link.text(remainingDays + " days remaining");
            $label.show();
        }
    }

    private updateBadge(): void {
        const badge = this.$("#user-details-badge");
        let sku = this.model.Sku;
        this.$("#upgrade-link").hide();

        // tslint:disable-next-line:triple-equals
        if (this.model.UserId == 809) { sku = "justis-team"; }

        if (sku === "open") {
            this.$("#upgrade-link").show();
        }

        this.$(".sku-message").text(this.getSkuText(sku));
    }

    private getSkuText(sku: string): string {
        switch (sku) {
            case "justis-team":
                return "Justis Team";
            case "pro":
                return "Pro";
            case "open":
                return "Open";
            default:
                return "";
            }
    }

    private ipSigningIn() {
        const msg = "Signing in...";
        _.defer(() => {
            this.$("#sign-in-details").hide();
            this.$("#user-details").hide();
        });
        this.$("#ip-in-progress").text(msg).show();
    }

    private updateSignInState(): void {
        if (this.model.IsAuthenticated) {
            this.$("#ip-in-progress").hide();
            this.$("#sign-in-details").hide();
            this.$("#user-details").show();
        } else {
            this.$("#user-details").hide();
            this.$("#sign-in-details").show();
        }
    }

    private updateSignInType(): void {
        if (this.model.AuthenticatedByIp) {
            this.$("#user-details-normal").hide();
            this.$("#user-details-normal-mobile").hide();
            this.$("#ip-done").show();
            this.$("#user-details-ip").fadeIn("fast");
            this.$("#user-details-ip-mobile").fadeIn("fast");
        } else {
            this.$("#user-details-ip").hide();
            this.$("#user-details-ip-mobile").hide();
            this.$("#ip-done").hide();
            $("#user-details-normal").fadeIn("fast");
            $("#user-details-normal-mobile").fadeIn("fast");
        }
    }

    private updateUserName(): void {
        let name = this.model.Email;
        const authType = this.model.AuthenticationType;
        if (authType === "Athens") {
            name = this.model.OrganisationName;
        }
        this.$("#user-email span").text(name);
        this.$("#user-email-mobile span").text(name);
        this.$("#user-icon").prop("title", name);
        this.$("#user-email-menu span").text(name);
    }

    private updateOrganisation(): void {
        const orgName = this.model.OrganisationName;
        const tooltip = "IP recognised as: " + orgName;

        $("#organisation-name")
            .text(orgName)
            .prop("title", tooltip);
        $("#org-icon")
            .prop("title", tooltip);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/views/user-details.ts